import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  CircularProgress,
  Box,
} from '@mui/material';
import { useUpdateBrandMutation } from 'state/api';

const STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
];

const EditBrandDialog = ({ open, brand, onClose, onError }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [status, setStatus] = useState('active');
  const [updateBrand, { isLoading }] = useUpdateBrandMutation();

  // Pre-fill the form whenever a brand is selected for editing.
  useEffect(() => {
    if (brand) {
      setName(brand.name || '');
      setDescription(brand.description || '');
      setStatus(brand.status || 'inactive');
    }
  }, [brand]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!brand?._id || !name.trim()) return;
    try {
      await updateBrand({
        id: brand._id,
        name: name.trim(),
        description: description.trim(),
        status,
      }).unwrap();
      onClose();
    } catch (err) {
      if (onError) onError(err?.data?.message || 'Failed to update brand');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <form onSubmit={handleSubmit}>
        <DialogTitle>Edit Brand</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <TextField
              label="Brand Name"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <TextField
              label="Description"
              fullWidth
              multiline
              minRows={2}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            <TextField
              label="Status"
              select
              fullWidth
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              {STATUS_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button type="button" variant="outlined" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={isLoading || !name.trim()}
          >
            {isLoading ? <CircularProgress size={20} color="inherit" /> : 'Save Changes'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditBrandDialog;
